import {
  LLMModelTypeEnum,
  ModuleIOValueTypeEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  Input_Template_AiModel,
  Input_Template_History,
  Input_Template_Switch,
  Input_Template_System_Prompt,
  Input_Template_UserChatInput,
} from '../input';
import { chatNodeSystemPromptTip } from '../tip';
import { Output_Template_Finish, Output_Template_UserChatInput } from '../output';
import { FlowModuleTemplateType } from '../../types';
import { FlowNodeOutputTypeEnum, FlowNodeTypeEnum } from '../../node/constants';

export const ToolModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.tools,
  flowType: FlowNodeTypeEnum.tools,
  templateType: ModuleTemplateTypeEnum.functionCall,
  avatar: '/imgs/module/tool.svg',
  name: '工具调用（实验）',
  description: '通过AI模型自动选择一个或多个工具进行调用。工具可以是其他功能块或插件。',
  inputs: [
    Input_Template_Switch,
    {
      ...Input_Template_AiModel,
      llmModelType: LLMModelTypeEnum.toolCall,
    },
    {
      ...Input_Template_System_Prompt,
      label: '提示词',
      description: chatNodeSystemPromptTip,
      placeholder: chatNodeSystemPromptTip,
    },
    Input_Template_History,
    Input_Template_UserChatInput,
  ],
  outputs: [
    Output_Template_UserChatInput,
    {
      key: ModuleOutputKeyEnum.selectedTools,
      valueType: ModuleIOValueTypeEnum.tools,
      type: FlowNodeOutputTypeEnum.hidden,
      targets: [],
    },
    Output_Template_Finish,
  ],
};
